import { get } from "./request";
import request from "./request";

/**
 * 用户信息接口（API 文档第 2 节 /console/user）。
 */

export interface UserProfile {
  userId: number;
  email: string;
  companyName: string;
  onboardingCompleted: boolean;
}

/** GET /user/profile */
export function getProfile(): Promise<UserProfile> {
  return get<UserProfile>("/user/profile");
}

/** PUT /user/password */
export function updatePassword(
  currentPassword: string,
  newPassword: string
): Promise<{ message: string }> {
  return request.put("/user/password", {
    currentPassword,
    newPassword,
  }) as unknown as Promise<{ message: string }>;
}
